import { useEffect, useState } from 'react';

export type SellerNotice = { seq: number; type: 'sn'; content: string; crt_dt?: string };
export const SELLER_NOTICE_EVENT = 'fanbird:seller-notice-updated';
export function sellerNoticeUpdated(liveSeq: number) {
  window.dispatchEvent(new CustomEvent(SELLER_NOTICE_EVENT, { detail: { liveSeq } }));
}

export function useSellerChat(liveSeq: number, load: (liveSeq: number) => Promise<SellerNotice[]>, enabled = true) {
  const [state, setState] = useState({ liveSeq, messages: [] as SellerNotice[], loading: enabled, error: '' });
  useEffect(() => {
    setState({ liveSeq, messages: [], loading: enabled, error: '' });
    if (!enabled || !Number.isSafeInteger(liveSeq) || liveSeq < 1) return;
    let active = true, running = false;
    const refresh = async () => {
      if (running) return;
      running = true;
      try {
        const data = await load(liveSeq);
        if (active && Array.isArray(data)) {
          setState({ liveSeq, loading: false, error: '', messages: data
            .filter(item => item?.type === 'sn' && typeof item.content === 'string' && item.content.trim())
            .sort((a, b) => Number(a.seq) - Number(b.seq)) });
        }
      } catch { if (active) setState(current => ({ ...current, loading: false, error: '셀러 채팅을 불러오지 못했습니다.' })); }
      finally { running = false; }
    };
    const updated = (event: Event) => {
      if ((event as CustomEvent).detail?.liveSeq === liveSeq) void refresh();
    };
    const focus = () => { if (!document.hidden) void refresh(); };
    void refresh();
    window.addEventListener(SELLER_NOTICE_EVENT, updated); window.addEventListener('focus', focus);
    // The authenticated API also catches edits made through a different local socket environment.
    const timer = window.setInterval(focus, 2500);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener(SELLER_NOTICE_EVENT, updated); window.removeEventListener('focus', focus); };
  }, [liveSeq, load, enabled]);
  return enabled && state.liveSeq === liveSeq ? state : { liveSeq, messages: [], loading: false, error: '' };
}

export function useSellerNotice(liveSeq: number, load: (liveSeq: number) => Promise<SellerNotice[]>, enabled = true) {
  return useSellerChat(liveSeq, load, enabled).messages.at(-1)?.content ?? '';
}
